/* @flow  */
import { css } from 'linaria';

export default {
  default: css`
    box-sizing: inherit;
    flex-basis: 100%;
    min-width: 0;
    width: unset;
  `,
  size1of12: css`
    flex-basis: auto;
    width: calc(100% * 1 / 12);
  `,
  size2of12: css`
    flex-basis: auto;
    width: calc(100% * 1 / 6);
  `,
  size3of12: css`
    flex-basis: auto;
    width: 25%;
  `,
  size4of12: css`
    flex-basis: auto;
    width: calc(100% * 1 / 3);
  `,
  size5of12: css`
    flex-basis: auto;
    width: calc(100% * 5 / 12);
  `,
  size6of12: css`
    flex-basis: auto;
    width: 50%;
  `,
  size7of12: css`
    flex-basis: auto;
    width: calc(100% * 7 / 12);
  `,
  size8of12: css`
    flex-basis: auto;
    width: calc(100% * 2 / 3);
  `,
  size9of12: css`
    flex-basis: auto;
    width: 75%;
  `,
  size10of12: css`
    flex-basis: auto;
    width: calc(100% * 5 / 6);
  `,
  size11of12: css`
    flex-basis: auto;
    width: calc(100% * 11 / 12);
  `,
  size12of12: css`
    flex-basis: auto;
    width: 100%;
  `,
  size1of5: css`
    flex-basis: auto;
    width: 20%;
  `,
  sizeFit: css`
    flex-basis: auto;
    width: unset;
  `,
  sizeFill: css`
    flex: 1 1 0%;
    flex-basis: 0%;
    width: unset;
  `,
  sizeFillAlt: css`
    flex: 1 1 auto;
    flex-basis: auto;
    width: unset;
  `,
  sizeFull: css`
    width: 100%;
  `,
};



// WEBPACK FOOTER //
// ./src/ui/constants/Size.js